import axios from 'axios';
import user from '../utils/user';

async function saveOccurrence(payload, entityType) {
  try {
    const formDataSend = new FormData();

    payload.attachments.forEach((file) => {
      formDataSend.append('files', file);
    });

    formDataSend.append('description', payload.description);

    const response = await axios.post(
      `${process.env.VUE_APP_API_VIDA_URL}/${entityType}/${payload.entityId}/occurrences`,
      formDataSend,
      {
        headers: {
          Authorization: `Bearer ${user.getUserAuthToken()}`,
          'Content-Type': 'multipart/form-data',
        },
      },
    );

    return response.data;
  } catch (error) {
    throw error;
  }
}

async function getOccurrences(entityId, entityType) {
  try {
    const response = await axios.get(
      `${process.env.VUE_APP_API_VIDA_URL}/${entityType}/${entityId}/occurrences`,
      {
        headers: {
          Authorization: `Bearer ${user.getUserAuthToken()}`,
        },
      },
    );
    return response.data;
  } catch (error) {
    throw error;
  }
}

export default {
  async getPolicyOccurrences(policyId) {
    return await getOccurrences(policyId, 'policy');
  },

  async getConsultancyOccurrences(consultancyId) {
    return await getOccurrences(consultancyId, 'consultancies');
  },
  async getBrokerOccurrences(brokerId) {
    return await getOccurrences(brokerId, 'brokers');
  },

  async getCovenantOccurrences(covenantId) {
    return await getOccurrences(covenantId, 'covenants');
  },

  async saveBrokerOccurrence(payload) {
    return await saveOccurrence(payload, 'brokers');
  },

  async saveConsultancyOccurrence(payload) {
    return await saveOccurrence(payload, 'consultancies');
  },

  async saveCovenantOccurrence(payload) {
    return await saveOccurrence(payload, 'covenants');
  },

  async savePolicyOccurrence(payload) {
    return await saveOccurrence(payload, 'policy');
  },
};
